/**
 * useAppProjects Hook
 *
 * Wraps useUnifiedProjects from shared-ui and filters to Flux DC projects.
 */

import { useUnifiedProjects } from '@vortx/shared-ui';
import { appConfig } from '../config/appConfig';

/**
 * Get all projects for Flux DC
 *
 * @returns {Object} { projects, loading, error, refresh }
 */
export function useAppProjects() {
  return useUnifiedProjects(appConfig.appKey);
}

export default useAppProjects;
